import { html, TemplateResult, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import globalStyles from './styles/outline-logo.global.css?inline';
import encapsulatedStyles from './styles/outline-logo.encapsulated.css?inline';
import { AdoptedStyleSheets } from '../../controllers/adopted-stylesheets';
import { classMap } from 'lit/directives/class-map.js';

export const logoVariants = ['text', 'seal'] as const;
export type LogoVariant = (typeof logoVariants)[number];

/**
 * The element name, reused throughout the codebase
 * @type {string}
 */
const componentName = 'outline-logo';

/**
 * The Outline Core Logo component
 *
 * A reusable LitElement component for displaying logos.
 *
 * @element outline-logo
 * @extends LitElement
 */
@customElement(componentName)
export class OutlineLogo extends LitElement {
  /**
   * Adopted stylesheets for the component
   *
   * @type {AdoptedStyleSheets}
   */
  adoptedStyleSheets = new AdoptedStyleSheets(this, {
    globalCSS: globalStyles,
    encapsulatedCSS: encapsulatedStyles,
  });

  @property({type: String, reflect: true})
  variant: LogoVariant;
  
  @property({type: String, reflect: true})
  size: string;

  connectedCallback() {
    super.connectedCallback();
    if(this.size) {
      this.style.setProperty('--logo-size', `${this.size}`)
    }
  }

  updated() {
    this.setValues();
  }

  setValues() {
    if(this.size) {
      this.style.setProperty('--logo-size', `${this.size}`)
    }
  }

  render(): TemplateResult {
    const wrapperClasses = {
      'outline-logo': true,
      [this.variant]: true,
    }

    return html`
    <div class="${classMap(wrapperClasses)}">
    </div>
    `;
  }
}

/**
 * Declare the component in the global HTMLElementTagNameMap
 */
declare global {
  interface HTMLElementTagNameMap {
    [componentName]: OutlineLogo;
  }
}
